import React from 'react';
import PropTypes from 'prop-types';
import FlexContainer from '../FlexContainer/FlexContainer';
import LegendItem from './LegendItem';
import css from './ChartLegend.module.scss';

const ChartLegend = ({
  items = [],
  gap = 15,
  flexWrap = 'nowrap',
  align = 'flex-start'
}) => {
  return (
    <FlexContainer 
      className={css.chartLegend} 
      flexWrap={flexWrap} 
      gap={gap}
      alignItems="center"
      justifyContent={align}
    >
      {items.map((item, index) => (
        <LegendItem
          key={index}
          label={item.label}
          color={item.color}
        />
      ))}
    </FlexContainer>
  );
};

ChartLegend.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  gap: PropTypes.number,
  flexWrap: PropTypes.string,
  align: PropTypes.string,
};

ChartLegend.defaultProps = {
  gap: 15,
  flexWrap: 'nowrap',
  align: 'flex-start',
};

export default ChartLegend;
